var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, IconButton, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowRight } from '@phosphor-icons/react';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppConsts } from '../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../application/common/helpers/grid-filter-operators';
import { useGetPaginatedTechniciansQuery } from '../../../application/features/technicians/technician-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import ProtectedElement from '../../components/ProtectedElement';
import { Permissions } from '../../permissions';
import TechniciansCards from './technician-cards';
import { TechniciansDatagrid } from './technician-datagrid';
import ActivateTechnicianDialog from './technician-status/ActivateTechnician';
import DeActivateTechnicianDialog from './technician-status/DeActivateTechnician';
var Technicians = function () {
    var theme = useTheme();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _a = __read(useState(false), 2), openFilterDrawer = _a[0], setOpenFilterDrawer = _a[1];
    var _b = __read(useSearchParams(), 1), searchParams = _b[0];
    var technicianId = searchParams.get('id');
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isSm = useMediaQuery(theme.breakpoints.only('sm'));
    var isMd = useMediaQuery(theme.breakpoints.only('md'));
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var iscreen9001200 = useMediaQuery('(min-width:900px) and (max-width:1200px)');
    var isscreen9001200Landscape = useMediaQuery('(min-width:900px) and (max-width:1200px) and (orientation: landscape)');
    var isIpadMini = useMediaQuery('(max-width: 768px)');
    var isIpadMiniLandscape = useMediaQuery('(max-width: 1024px) and (orientation: landscape)');
    var navigate = useNavigate();
    var _c = __read(useState({ isOpen: false, isActive: false }), 2), technicianStatusModal = _c[0], setTechnicianStatusModal = _c[1];
    var technicianLevelLabels = [
        translate('technicians.technicianLevels.junior'),
        translate('technicians.technicianLevels.senior'),
        translate('technicians.technicianLevels.service'),
        translate('technicians.technicianLevels.allRound')
    ];
    var technicianLevelOptions = [
        { value: 'Junior', label: translate('technicians.technicianLevels.junior') },
        { value: 'Senior', label: translate('technicians.technicianLevels.senior') },
        { value: 'Service', label: translate('technicians.technicianLevels.service') },
        { value: 'AllRound', label: translate('technicians.technicianLevels.allRound') }
    ];
    var _d = __read(useState({
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined,
        isFilterEnum: false
    }), 2), technicianFilter = _d[0], setTechnicianFilter = _d[1];
    var _e = __read(useState({
        items: []
    }), 2), filterModel = _e[0], setFilterModel = _e[1];
    var data = useGetPaginatedTechniciansQuery(technicianFilter, {
        refetchOnMountOrArgChange: true
    }).data;
    var _f = (data !== null && data !== void 0 ? data : {}).items, technicians = _f === void 0 ? [] : _f;
    var activationModalOpen = technicianStatusModal.isOpen && technicianStatusModal.isActive;
    var deActivationModalOpen = technicianStatusModal.isOpen && !technicianStatusModal.isActive;
    useEffect(function () {
        if (technicianId !== null) {
            setTechnicianFilter(function (filters) {
                return __assign(__assign({}, filters), { id: technicianId });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [technicianId]);
    var handleFilterModelChange = function (model) {
        var _a;
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setTechnicianFilter(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                var filterValue_1 = (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString();
                setTechnicianFilter(function (prev) { return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: filterValue_1, isFilterEnum: filterItem_1.operator === 'isAnyOf' && filterItem_1.field === 'level' })); });
            }
        }
        else {
            setTechnicianFilter(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var handlePaginationModelChange = function (model) {
        setTechnicianFilter(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setTechnicianFilter(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var rowCountRef = React.useRef((data === null || data === void 0 ? void 0 : data.totalCount) || 0);
    var rowCount = React.useMemo(function () {
        if ((data === null || data === void 0 ? void 0 : data.totalCount) !== undefined) {
            rowCountRef.current = data === null || data === void 0 ? void 0 : data.totalCount;
        }
        return rowCountRef.current;
    }, [data === null || data === void 0 ? void 0 : data.totalCount]);
    var openTechnicianActivationModal = function (technician, isActive) {
        setTechnicianStatusModal({
            technician: technician,
            isOpen: true,
            isActive: isActive
        });
    };
    var closeTechnicianStatusModal = function () {
        setTechnicianStatusModal({
            isOpen: false,
            isActive: false
        });
    };
    var columns = __spreadArray(__spreadArray([
        {
            field: 'fullName',
            headerName: translate('common.name'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            filterOperators: getFilteredStringOperators(),
            renderCell: function (params) { return (_jsxs(Box, { children: [_jsx(Typography, { children: params.row.fullName }), _jsx(Typography, { variant: 'caption', color: 'textSecondary', sx: { wordBreak: 'break-word' }, children: params.row.email })] })); }
        }
    ], __read(((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin
        ? [
            {
                field: 'company',
                headerName: translate('common.company'),
                flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
                minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
                width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
                filterOperators: getFilteredStringOperators()
            }
        ]
        : [])), false), [
        {
            field: 'level',
            headerName: translate('technicians.level'),
            flex: isXs ? undefined : isMd ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            type: 'singleSelect',
            valueOptions: technicianLevelOptions,
            filterable: true,
            renderCell: function (params) { return (_jsx(Typography, { children: technicianLevelLabels[params.row.level] })); }
        },
        {
            field: 'isActive',
            headerName: translate('common.active'),
            headerAlign: 'center',
            align: 'center',
            filterable: false,
            minWidth: 150,
            renderCell: function (params) { return (_jsx(ProtectedElement, { permissions: [Permissions.Technicians.Update], children: _jsx(Switch, { sx: { mx: 'auto' }, checked: params.row.isActive, onChange: function (e) { return openTechnicianActivationModal(params.row, e.target.checked); } }) })); }
        },
        {
            field: 'details',
            headerName: translate('common.details'),
            headerAlign: 'right',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            align: 'right',
            renderCell: function (params) { return (_jsx(IconButton, { onClick: function () { return navigate("/technicians/".concat(params.row.id)); }, children: _jsx(ArrowRight, {}) })); }
        }
    ], false);
    return (_jsxs(Box, { sx: {
            padding: isXs ? '16px' : '8px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }, children: [_jsx(Box, { padding: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', children: _jsx(Typography, { variant: isXs ? 'h4' : 'h3', color: '#009983', children: translate('common.technicians') }) }), isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(TechniciansCards, { technicians: technicians, technicianFilter: technicianFilter, setTechnicianFilter: setTechnicianFilter, onStatusChange: function (tech, isActive) { return openTechnicianActivationModal(tech, isActive); }, onDetails: function (id) { return navigate("/technicians/".concat(id)); }, technicianLevelLabels: technicianLevelLabels })) : (_jsx(TechniciansDatagrid, { technicians: technicians, columns: columns, rowCount: rowCount, paginationModel: {
                    page: technicianFilter.page - 1,
                    pageSize: technicianFilter.pageSize
                }, onPaginationModelChange: handlePaginationModelChange, onSortModelChange: handleSortModelChange, openFilterDrawer: openFilterDrawer, setOpenFilterDrawer: setOpenFilterDrawer, onFilterModelChange: handleFilterModelChange, filterModel: filterModel, isXs: isXs, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen9001200Landscape: isscreen9001200Landscape })), activationModalOpen && (_jsx(ActivateTechnicianDialog, { technician: technicianStatusModal.technician, isOpen: activationModalOpen, onClose: closeTechnicianStatusModal })), deActivationModalOpen && (_jsx(DeActivateTechnicianDialog, { technician: technicianStatusModal.technician, isOpen: deActivationModalOpen, onClose: closeTechnicianStatusModal }))] }));
};
export default Technicians;
